class ShellItemModel {
  id;
  description;
  order;
  redirectTo;
  title;
  learnMoreUrl;
  videoUrl;
  children;
  image;

  constructor(options = {}) {
    this.id = options.id;
    this.description = options.description;
    this.order = options.order;
    this.redirectTo = options.redirectTo;
    this.title = options.title;
    this.learnMoreUrl = options.learnMoreUrl;
    this.videoUrl = options.videoUrl;
    this.children = (options.subComponents || []).map(i => (new ShellItemModel(i)));
    this.image = options.image;
  }
}

export default ShellItemModel;
